export function getFileExtension(filename = '') {
  const name = String(filename || '').trim().toLowerCase();
  if (name.endsWith('.pdf')) return 'pdf';
  if (name.endsWith('.docx')) return 'docx';
  if (name.endsWith('.doc')) return 'doc';
  return '';
}

export function safeFilename(name = '') {
  return String(name || '').replace(/[^A-Za-z0-9._-]/g, '_');
}

export function triggerFileDownload(url, fileName = 'document') {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function openOrDownloadDocument({ url, fileName, onOpenPdf, onNotify }) {
  if (!url || url === '#') {
    onNotify?.('Aucun document disponible pour cet element.', 'warning');
    return 'missing';
  }

  const extension = getFileExtension(fileName);

  if (extension === 'doc' || extension === 'docx') {
    triggerFileDownload(url, fileName || `document.${extension}`);
    onNotify?.('Document Word telecharge. Ouvrez-le avec le logiciel de votre choix.', 'info');
    return 'word';
  }

  if (typeof onOpenPdf === 'function') {
    onOpenPdf();
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  return extension || 'opened';
}
